<template>
  <div>
    <section class="section--title-page has-no-margin">
      <h3>Aggiungi opzione</h3>
      <a @click="addOption()" class="btn"><i class="fa fa-plus-circle"></i> {{__("misc.new")}}</a>
    </section>
    <div class="options">
      <draggable
        :list="new_options"
        :disabled="!enabled"
        class="list-group"
        ghost-class="ghost"
        :move="checkMove"
        @start="dragging = true"
        @end="dragging = false"
      >
        <div v-for="(option, index) in this.new_options">
          <div class="single--item">
            <div class="single--item-move">
              <i class="fal fa-bars"></i>
            </div>
            <div class="single--item-index">
              {{index}}
            </div>
            <div class="single--item-info">
              <input type="text" :value="option" name="eav_field[field_options][]" />
            </div>
            <div class="single--item-button">
              <i @click="removeOption(index)" class="fal fa-trash-alt"></i>
            </div>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
  import draggable from "vuedraggable";
  export default {
    name: "simple",
    display: "Simple",
    order: 0,
    components: {
      draggable
    },
    mounted() {
      this.new_options = this.options;
    },
    data() {
      return {
        new_options: [],
        enabled: true,
        // list: [
        //   { name: "John", id: 0 },
        //   { name: "Joao", id: 1 },
        //   { name: "Jean", id: 2 }
        // ],
        dragging: false
      };
    },
    computed: {
      draggingInfo() {
        return this.dragging ? "under drag" : "";
      }
    },
    methods: {
      // add: function() {
      //   this.list.push({ name: "Juan " + id, id: id++ });
      // },
      // replace: function() {
      //   this.list = [{ name: "Edgard", id: id++ }];
      // },
      checkMove(e) {
        window.console.log("Future index: " + e.draggedContext.futureIndex);
      },
      addOption() {
        this.new_options.push("");
      },
      removeOption(index) {
        this.new_options.splice(index,1);
      }
    },
    props: {
      options: {
        type: Array
      }
    }
  };
  // export default {
  //   mounted() {
  //     this.new_options = this.options;
  //   },
  //   data()  {
  //     return {
  //       new_options: []
  //     }
  //   },

  //   methods: {
  //     addOption() {
  //       this.new_options.push("");
  //     },
  //     removeOption(index) {
  //       this.new_options.splice(index,1);
  //     }

  //   },
  //   props: {
  //     options: {
  //       type: Array
  //     }
  //   }
  // }
</script>

